export const pt = {
  kicker: "OLÁ",
  headingLine1: "Eu sou Levy Santiago,",
  headingLine2: "back-end engineer",
  body: "Mais de seis anos desenvolvendo sistemas que impactam a vida das pessoas, usando IA como parte da minha caixa de ferramentas.",
  primaryCta: "Entrar em contato",
  secondaryCta: "Ver GitHub",
  portraitLabel: "Foto do Levy",
};
